import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import loadable from '@loadable/component';
import ProtectedRoute from './components/ProtectedRoute';
import { RequestCallbackScreen } from './pages';
import AnonymousRequestCallbackScreen from '@pages/AnonymousRequestCallbackScreen';
import PlaygroundScreen from '@pages/restorgram/PlaygroundScreen';
import InquiryCallbackScreen from '@pages/InquiryCallbackScreen';
import { IntercomProvider } from 'react-use-intercom';
import ApprovalCallbackScreen from '@pages/ApprovalCallbackScreen';

const DashboardLayout = loadable(() => import('./components/DashboardLayout'));
const AuthScreen = loadable(() => import('./pages/AuthScreen'));
const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || '';

export interface CustomRouteProps {
  isExact: boolean;
  component:
    | React.ComponentType<RouteComponentProps<any, StaticContext, unknown>>
    | React.ComponentType<any>;
  path: string;
}

export const routeList: CustomRouteProps[] = [
  {
    isExact: true,
    component: () => (
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      </IntercomProvider>
    ),
    path: '/app/',
  },
  {
    isExact: false,
    component: () => (
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      </IntercomProvider>
    ),
    path: '/app/:tabName',
  },
  {
    isExact: true,
    component: () => (
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
        <AuthScreen />,
      </IntercomProvider>
    ),
    path: '/',
  },
  {
    isExact: true,
    component: () => <PlaygroundScreen />,
    path: '/playground',
  },
  {
    isExact: true,
    component: () => <RequestCallbackScreen />,
    path: '/request/:requestId/callback/',
  },
  {
    isExact: true,
    component: () => <InquiryCallbackScreen />,
    path: '/inquiry/:inquiryId/',
  },
  {
    isExact: true,
    component: () => <ApprovalCallbackScreen />,
    path: '/approval/reviews/:googleReviewId/',
  },
  {
    isExact: true,
    component: () => <AnonymousRequestCallbackScreen />,
    path: '/request/location/:locationId/callback/',
  },
];
